import {
    createSchedulerRuleException,
    deleteSchedulerRuleException,
    fetchSchedulerRuleExceptions,
    updateSchedulerRuleException,
} from "store/features/emailScheduler/exceptions/exceptions.actions";
import { call, put } from "redux-saga/effects";
import emailScheduler, { Exception } from "api/emailScheduler";
import {
    buildEmailSchedulerRuleExceptionModel,
    buildSchedulerRuleExceptionViewModel,
} from "api/factories/emailScheduler.factory";
import { resetApiError, riseError } from "store/features/general/general.actions";

export function* createEmailSchedulerRuleExceptionSaga(
    headers: HeadersInit,
    action: ReturnType<typeof createSchedulerRuleException.request>
): Generator {
    try {
        yield call(
            emailScheduler.createSchedulerRuleException,
            buildEmailSchedulerRuleExceptionModel(action.payload),
            headers
        );
        yield put(createSchedulerRuleException.success());
    } catch (err) {
        if (err.status) {
            yield put(createSchedulerRuleException.failure({ statusCode: err.status }));
            yield put(resetApiError());

            return;
        }

        yield put(riseError(err));
    }
}

export function* updateEmailSchedulerRuleExceptionSaga(
    headers: HeadersInit,
    action: ReturnType<typeof updateSchedulerRuleException.request>
): Generator {
    try {
        yield call(
            emailScheduler.updateSchedulerRuleException,
            buildEmailSchedulerRuleExceptionModel(action.payload),
            headers
        );
        yield put(updateSchedulerRuleException.success());
    } catch (err) {
        if (err.status) {
            yield put(updateSchedulerRuleException.failure({ statusCode: err.status }));
            yield put(resetApiError());

            return;
        }

        yield put(riseError(err));
    }
}

export function* fetchEmailSchedulerRuleExceptionSaga(headers: HeadersInit): Generator {
    try {
        const exceptions = (yield call(emailScheduler.getSchedulerRuleExceptions, headers)) as Exception[];
        yield put(
            fetchSchedulerRuleExceptions.success({
                exceptions: buildSchedulerRuleExceptionViewModel(exceptions),
            })
        );
    } catch (err) {
        if (err.status) {
            yield put(fetchSchedulerRuleExceptions.failure({ statusCode: err.status }));
            yield put(resetApiError());

            return;
        }

        yield put(riseError(err));
    }
}

export function* deleteSchedulerRuleExceptionSaga(
    headers: HeadersInit,
    action: ReturnType<typeof deleteSchedulerRuleException.request>
): Generator {
    try {
        yield call(emailScheduler.deleteExceptionRule, action.payload.id, headers);
        yield put(deleteSchedulerRuleException.success());
        yield call(fetchEmailSchedulerRuleExceptionSaga, headers);
    } catch (err) {
        if (err.status) {
            yield put(deleteSchedulerRuleException.failure({ statusCode: err.status }));
            yield put(resetApiError());

            return;
        }

        yield put(riseError(err));
    }
}
